// The component is set up to handle different subscription 
// plans and dispatch corresponding actions based on user interactions.
import React from 'react';
import {  FaCheck } from 'react-icons/fa';
import {  useDispatch } from 'react-redux';
import { 
        startProSub, } from '../../features/subscription/subscriptionSlice';


const PricingTable = () => {
    const dispatch = useDispatch();

    

    // function to dispatch the startProSub action, which starts a pro subscription
    const handleStartProSub = () => {
        dispatch(startProSub());
    };

    return (
        <>
            <div className="rounded-md flex justify-around flex-col space-y-4 p-2 sm:flex-row sm:space-y-0 sm:space-x-4 md:bg-gradient-to-r from-teal via-charcoal to-black">
                {/* Basic Card */}
                <div className="bg-gradient-to-b from-charcoal to-teal shadow-lg flex-1 flex flex-col justify-between transform transition-transform hover:scale-105 hover:shadow-2xl rounded-lg">
                    <div className='mt-2 py-4 px-8'>
        
                        
                        {/* Pricing for second card */}
                        <div className="text-left">
                            <div className='mt-2'>
                                <h1 className="text-5xl font-bold text-ivory">
                                    $30
                                    <span className="text-ivory text-xs font-sans"> /mo/jobsite</span>
                                </h1>
                            </div>
                            {/* Removed yearly price section */}
                        </div>
                        {/* conditionally render buttons */}
                        <button
                            type="button"
                            className="bg-gradient-to-r from-robin to-lilac font-bold mt-4 py-2 px-4 rounded-lg w-full text-teal hover:from-sage hover:to-robin"
                            onClick={handleStartProSub}
                        >
                            Resume Subscription
                        </button>
                        <div className="text-tan text-sm mt-2 mb-4 text-left">
                            
                            <ul className='mt-1'>
                                <li className="flex items-center "><FaCheck className="text-orangem text-lg" /><span className="ml-2">Unlimited Jobsites</span></li>
                                <li className="flex items-center "><FaCheck className="text-orangem text-lg" /><span className="ml-2">Message Board</span></li>
                                <li className="flex items-center"><FaCheck className="text-orangem text- lg" /><span className="ml-1">Unlimited Workers</span></li>
                                <li className="flex items-center"><FaCheck className="text-orangem text-lg" /><span className="ml-1">Liveness check</span></li>
                            </ul>
                        </div>
                    </div>
                </div>

       
            </div>
        </>
    );
};

export default PricingTable;
